import React from 'react';
import { useNavigate } from 'react-router-dom';



function CotisationCoach(props) {
  const Navigate = useNavigate();


  return (
    <>
        {props.userData && (
            <>
              <h2>Cotisations</h2>

              <div className="card-body">
                  <div className="ajout">
                      <form className="Invite_Joueur">
                          <div>
                          Vous avez la possibilité de superviser les cotisations des joueurs, de traiter les paiements et de restreindre l'accès au site en cas de retard de paiement, garantissant une gestion financière précise et sans faille pour l'équipe. Vous pouvez simplement gérer les cotisations des joueurs et, si vous souhaitez voir plus de détails, cliquer sur "Accéder à la gestion des cotisations".                          </div>
                          <br />
                          <button type="submit" style={{ margin: "auto" }} onClick={() => Navigate('/coach/accueil/cotisation')} className="conect">
                              Accéder à la gestion des cotisations
                          </button>
                      </form>
                  </div>
              </div>
       
            </>


        )}


      
    </>
    
  );
}

export default CotisationCoach;
